import React, { useState } from 'react'
import { Navigate, Link, useNavigate } from 'react-router-dom'
import { createStore } from '../../store/state'
import logo from '../../assets/logo.png';
import api from '../../controller/api';
import { toast, Toaster } from "sonner"
import { BiLoader } from "react-icons/bi"
import { useGoogleLogin } from "@react-oauth/google"
import { FcGoogle } from "react-icons/fc";
import loginImg from "../../assets/doctor-login.png"

export default function Login() {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)

    const { user, setCredentials } = createStore((state) => state)

    const navigate = useNavigate()

    const handleLogin = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            if (!username || !password) return toast.error("Enter required fields")

            const userData = {
                username: username,
                password: password
            }

            const { data: res } = await api.post("/user/login", userData)
            if (res?.user) {
                toast.success("Account created")
                const userInfo = { ...res?.user, token: res.token };
                localStorage.setItem("user", JSON.stringify(userInfo))
                setCredentials(userInfo)
                setTimeout(() => {
                    navigate('/overview');
                }, 1500)
            }
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const responseGoolge = async (authResult) => {
        try {
            if (authResult['code']) {
                const code = authResult['code']
                const { data: res } = await api.post("/user/google-login", { code })
                if (res?.user) {
                    toast.success("Login successfully")
                    const userInfo = { ...res?.user, token: res.token };
                    localStorage.setItem("user", JSON.stringify(userInfo))
                    setCredentials(userInfo)
                    setTimeout(() => {
                        navigate('/overview');
                    }, 1500)
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const googleLogin = useGoogleLogin({
        onSuccess: responseGoolge,
        onError: responseGoolge,
        flow: "auth-code"
    })

    return <div className='login-page'>
        <Toaster richColors position="top-center" />
        {user ? <Navigate to="/" /> : <div className='login-section'>
            <div className='login-img'><img src={loginImg} alt='Kogin Graphic' /></div>
            <div className="login-form">
                <Link to="/"><img src={logo} alt="Home Salon logo" className="login-logo" /></Link>

                <button
                    onClick={googleLogin}
                    className="google-btn"
                    type="submit"
                >
                    <FcGoogle style={{ width: "30px" }} />
                    Sign In with Google
                </button>

                <form onSubmit={handleLogin}>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">User Name</label>
                        <input className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter username" type="text" />
                    </div>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">Password</label>
                        <input className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" type="password" />
                    </div>
                    <div className="input-box">
                        <button className='login-btn'>{loading ? <BiLoader size={24} className='animate-spin' /> : "Login"}</button>
                    </div>
                </form>
                <p><Link to="/register" className='btn-credential'>Register here</Link></p>
                <p><Link to="/forgot-password">Forgot Password</Link></p>
            </div>
        </div>}
    </div>

}
